import React, {FC, useMemo} from 'react';
import twttr from 'twitter-text';

import {ChannelModel} from '../../../models/api/channelModel';
import {ChatComposerCounter} from './chatComposerCounter';

interface TweetComposerCountProps {
  text: string;
  channel: ChannelModel;
}

export const TweetComposerCounter: FC<TweetComposerCountProps> = (props) => {
  const textLength = useMemo(() => twttr.parseTweet(props.text).weightedLength, [props.text]);

  return <ChatComposerCounter textLength={textLength} channel={props.channel} />;
};
